import axios from "axios";
import React, { useState } from "react";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

function ShiftOpenForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [openingBalance, setOpenBalance] = useState("");
  const [loading, setLoading] = useState(false);

  // const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    axios
      .post(
      `${apiKey}/api/rms/admin/shift/open`,
        {
          opening_balance: openingBalance,
          outlet_id: user?.user?.outlet_id,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        window.location.href = "/admin/home";
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl">Open Register</h1>
          </div>
        </div>
        <div className="w-full">
          <form onSubmit={handleSubmit} className="w-full">
            <label htmlFor="">
              <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                Open Balance
              </span>
              <div className="mb-2 pt-0">
                <input
                  type="text"
                  placeholder="Open Balance"
                  className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  name="restaurant_name"
                  value={openingBalance}
                  onChange={(e) => setOpenBalance(e.target.value)}
                />
              </div>
            </label>
            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <button
              className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
              type="submit"
            >
              {loading && (
                <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                  <img
                    className="w-4 mx-auto"
                    src="https://i.gifer.com/ZKZx.gif"
                    alt=""
                  />
                </span>
              )}
              Submit
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}

export default ShiftOpenForm;
